module.exports = __webpack_public_path__ + "images/bg-user-case_da61cb8ccc44836f0c7a319690ba932a.png";